const IDENTIFICATION_KEY = 'identification';
const PHONE_KEY = 'phone';
const CONSENT_KEY = 'saveCredentialsConsent';

/**
 * Read previously saved guest credentials from sessionStorage.
 * Only returns values when the user previously opted in.
 */
export const getSavedCredentials = () => {
  try {
    const consent = sessionStorage.getItem(CONSENT_KEY) === 'true';
    if (!consent) {
      return { identification: '', phone: '', consent: false };
    }

    return {
      identification: sessionStorage.getItem(IDENTIFICATION_KEY) || '',
      phone: sessionStorage.getItem(PHONE_KEY) || '',
      consent: true,
    };
  } catch {
    return { identification: '', phone: '', consent: false };
  }
};

/** Persist identification + phone and mark consent as granted. */
export const saveCredentials = ({ identification = '', phone = '' } = {}) => {
  try {
    sessionStorage.setItem(IDENTIFICATION_KEY, String(identification || ''));
    sessionStorage.setItem(PHONE_KEY, String(phone || ''));
    sessionStorage.setItem(CONSENT_KEY, 'true');
  } catch {
    // Ignore storage failures (private mode / quota).
  }
};

/** Remove saved credentials and consent. */
export const clearSavedCredentials = () => {
  try {
    sessionStorage.removeItem(IDENTIFICATION_KEY);
    sessionStorage.removeItem(PHONE_KEY);
    sessionStorage.removeItem(CONSENT_KEY);
  } catch {
    // Ignore storage failures.
  }
};

/**
 * Save or clear credentials based on the user's remember preference.
 * Call this on successful form submit after the user answered the checkbox.
 */
export const persistCredentialsPreference = ({
  remember = false,
  identification = '',
  phone = '',
} = {}) => {
  if (remember) {
    saveCredentials({ identification, phone });
    return;
  }
  clearSavedCredentials();
};

/**
 * Merge saved credentials into an inputs object without overwriting
 * values already present (e.g. from query string).
 */
export const mergeSavedCredentials = (inputs = {}) => {
  const saved = getSavedCredentials();
  if (!saved.consent) return inputs;

  return {
    ...inputs,
    identification: inputs.identification || saved.identification || '',
    phone: inputs.phone || saved.phone || '',
  };
};
